"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignConfirmationOrganizerToJSON = exports.CampaignConfirmationOrganizerFromJSONTyped = exports.CampaignConfirmationOrganizerFromJSON = exports.instanceOfCampaignConfirmationOrganizer = void 0;
var runtime_1 = require("../runtime");
var OrderShipment_1 = require("./OrderShipment");
var ShippingAddress_1 = require("./ShippingAddress");
/**
 * Check if a given object implements the CampaignConfirmationOrganizer interface.
 */
function instanceOfCampaignConfirmationOrganizer(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignConfirmationOrganizer = instanceOfCampaignConfirmationOrganizer;
function CampaignConfirmationOrganizerFromJSON(json) {
    return CampaignConfirmationOrganizerFromJSONTyped(json, false);
}
exports.CampaignConfirmationOrganizerFromJSON = CampaignConfirmationOrganizerFromJSON;
function CampaignConfirmationOrganizerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'shippingAddress': !(0, runtime_1.exists)(json, 'shipping_address') ? undefined : (0, ShippingAddress_1.ShippingAddressFromJSON)(json['shipping_address']),
        'shipments': !(0, runtime_1.exists)(json, 'shipments') ? undefined : (json['shipments'] === null ? null : json['shipments'].map(OrderShipment_1.OrderShipmentFromJSON)),
    };
}
exports.CampaignConfirmationOrganizerFromJSONTyped = CampaignConfirmationOrganizerFromJSONTyped;
function CampaignConfirmationOrganizerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'shipping_address': (0, ShippingAddress_1.ShippingAddressToJSON)(value.shippingAddress),
        'shipments': value.shipments === undefined ? undefined : (value.shipments === null ? null : value.shipments.map(OrderShipment_1.OrderShipmentToJSON)),
    };
}
exports.CampaignConfirmationOrganizerToJSON = CampaignConfirmationOrganizerToJSON;
